import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoginHeader from '../components/header/LoginHeader';
import CustomLogin from '../components/auth/CustomLogin';

interface LoginProps {
}

const Login: React.FC<LoginProps> = () => {
  const { t } = useTranslation('login');

  return (
    <>
      <LoginHeader/>
      <div className="container">
        <div className="content">
          <CustomLogin />
          <br/>
        </div>
      </div>
    </>
  );
};

export default Login;
